const $inject = ["$scope", "AdminService"];

class ProfileController {
  constructor($scope, AdminService) {
    console.log("Constructing ProfileController");
    this.$scope = $scope;
    this.AdminService = AdminService;

    this.password = null;
    this.password_confirmation = null;
  }

  change_password() {
    let self = this;
    let data = {
      password: {
        first: this.password,
        second: this.password_confirmation,
      },
    };
    console.log(data);

    let handle_success = function (response) {
      console.log("Success", response);
      if (response.data) {
        self.success = response.data.success;
        self.message = response.data.message;
        self.errors = response.data.data.errors;

        if (self.success) {
          self.password = null;
          self.password_confirmation = null;

          let firstInputElement = document.getElementsByTagName("input")[0];
          firstInputElement.focus();
          firstInputElement.blur();
        }
      }
    };

    let handle_failure = function (response) {
      console.log("Failure", response);
    };

    this.AdminService.change_password(data, handle_success, handle_failure);
  }
}

ProfileController.$inject = $inject;
export default ProfileController;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/admin/controllers/profile.controller.js
 **/